import StatusHandler from 'app/shared-components/StatusHandler'
import useGetServiceCenterByLocation
    from 'app/Apps/ContainerManagement/ServiceCenters/hooks/useGetServiceCenterByLocation'

import {
    Order,
} from '../../orders.types'
import useGetOrderByNumber from '../../hooks/useGetOrderByNumber'
import useGetChangeRequestApproval from './hooks/useGetChangeRequestApproval'
import ChangeRequestApproval from './ChangeRequestApproval'

const ChangeRequestApprovalContainer = ({
    id: orderNumber,
}: {id: string}) => {
    const {
        data: order = {} as Order,
        isDataReady: isDataReadyOrder,
    } = useGetOrderByNumber(orderNumber)

    const {
        data: requestApproval,
    } = useGetChangeRequestApproval(orderNumber)

    const {
        data: serviceCenter,
        isFetching,
        isError,
        isDataReady,
        error,
    } = useGetServiceCenterByLocation(requestApproval?.selectedOriginServiceCenter?.id)

    return (
        <StatusHandler
            isSuccess={isDataReady && isDataReadyOrder}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <ChangeRequestApproval
                order={order}
                requestApproval={requestApproval}
                serviceCenter={serviceCenter}
            />
        </StatusHandler>
    )
}

export default ChangeRequestApprovalContainer
